import { useEffect, useState } from "react";
import useShowInventory from "@/domains/inventory/hooks/inventory/useShowInventory";
import useShowSearch from "@/domains/inventory/hooks/search/useShowSearch";
import useShowTrade from "@/domains/inventory/hooks/trade/useShowTrade";
import useUpdateInventory from "@/domains/inventory/hooks/useUpdateInventory";
import CharacterInventoryContainer from "@/domains/inventory/containers/CharacterInventoryContainer";
import SearchContainer from "@/domains/inventory/containers/SearchContainer";
import TradeContainer from "@/domains/inventory/containers/TradeContainer";

enum Inventory {
  Trade = "Trade",
  Inventory = "Inventory",
  Search = "Search",
}

const inventoryState: Record<Inventory, boolean> = {
  [Inventory.Trade]: false,
  [Inventory.Inventory]: false,
  [Inventory.Search]: false,
};

export default function InventoryContainer() {
  useUpdateInventory();
  const [inventoryShow, setInventoryShow] = useState<typeof inventoryState>(inventoryState);
  const { isShowInventory } = useShowInventory();
  const { isShowTrade } = useShowTrade();
  const { isShowSearch } = useShowSearch();

  useEffect(() => {
    setInventoryShow({ ...inventoryState, [Inventory.Inventory]: isShowInventory });
  }, [isShowInventory]);

  useEffect(() => {
    setInventoryShow({ ...inventoryState, [Inventory.Trade]: isShowTrade });
  }, [isShowTrade]);

  useEffect(() => {
    setInventoryShow({ ...inventoryState, [Inventory.Search]: isShowSearch });
  }, [isShowSearch]);

  return (
    <>
      <TradeContainer isOpen={inventoryShow.Trade} />
      <CharacterInventoryContainer isOpen={inventoryShow.Inventory} />
      <SearchContainer isOpen={inventoryShow.Search} />
    </>
  );
}
